import { post } from "./api";

export const importTransactions = (account_id, file) => {
  const formData = new FormData();
  formData.append("file_uploaded", file);
  return post(
    `/api/v2/bankaccounts/${account_id}/transaction_import/`,
    formData,
    "multipart/form-data"
  );
};
